export const WHATSAPP_NUMBER = '5491166252465'
export const WHATSAPP_DISPLAY = '+54 9 11 6625 2465'

export function whatsappLink(
  message = 'Hola Maestro, quiero solicitar mi consulta ahora.',
): string {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`
}
